var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("markdown-it"), require("markdown-it-emoji"), require("markdown-it-footnote"), require("markdown-it-task-lists"), require("./features/math"), require("./features/tag"), require("./features/widget"), require("./features/fence"), require("./features/wikilink"), require("../powerpack/fold-code-with-plantuml"), require("./transform"), require("./heading-id-generator"), require("./slide"), require("../powerpack/fold-code-with-echarts"), require("../powerpack/fold-code-with-mermaid"), require("../powerpack/fold-code-with-wavedrom"), require("../widget/index"), require("../powerpack/fold-code-with-vega"), require("../powerpack/fold-code-with-vega-lite"), require("../addon/emoji/index")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","markdown-it","markdown-it-emoji","markdown-it-footnote","markdown-it-task-lists","./features/math","./features/tag","./features/widget","./features/fence","./features/wikilink","../powerpack/fold-code-with-plantuml","./transform","./heading-id-generator","./slide","../powerpack/fold-code-with-echarts","../powerpack/fold-code-with-mermaid","../powerpack/fold-code-with-wavedrom","../widget/index","../powerpack/fold-code-with-vega","../powerpack/fold-code-with-vega-lite","../addon/emoji/index"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.Preview = this.HyperMD.Preview || {}), MarkdownIt, MarkdownItEmoji, MarkdownItFootnote, MarkdownItTaskLists, HyperMD.PreviewFeatureMath, HyperMD.PreviewFeatureTag, HyperMD.PreviewFeatureWidget, HyperMD.PreviewFeatureFence, HyperMD.PreviewFeatureWikiLink, HyperMD.FoldCodeWithPlantUML, HyperMD.PreviewTransform, HyperMD.PreviewHeadingIDGenerator, HyperMD.PreviewSlide, HyperMD.FoldCodeWithEcharts, HyperMD.FoldCodeWithMermaid, HyperMD.FoldCodeWithWavedrom, HyperMD.Widget, HyperMD.FoldCodeWithVega, HyperMD.FoldCodeWithVegaLite, HyperMD.Emoji);
})(function (require, exports, markdown_it_1, markdown_it_emoji_1, markdown_it_footnote_1, markdown_it_task_lists_1, math_1, tag_1, widget_1, fence_1, wikilink_1, fold_code_with_plantuml_1, transform_1, heading_id_generator_1, slide_1, fold_code_with_echarts_1, fold_code_with_mermaid_1, fold_code_with_wavedrom_1, index_1, fold_code_with_vega_1, fold_code_with_vega_lite_1, index_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.printPreview = exports.printPDF = exports.renderPreview = exports.renderMarkdown = void 0;
    markdown_it_1 = __importDefault(markdown_it_1);
    markdown_it_emoji_1 = __importDefault(markdown_it_emoji_1);
    markdown_it_footnote_1 = __importDefault(markdown_it_footnote_1);
    markdown_it_task_lists_1 = __importDefault(markdown_it_task_lists_1);
    math_1 = __importDefault(math_1);
    tag_1 = __importDefault(tag_1);
    widget_1 = __importDefault(widget_1);
    fence_1 = __importDefault(fence_1);
    wikilink_1 = __importDefault(wikilink_1);
    heading_id_generator_1 = __importDefault(heading_id_generator_1);
    index_2 = __importDefault(index_2);
    var md = new markdown_it_1.default({
        html: true,
        linkify: true,
        typographer: false,
        breaks: true,
    });
    md.use(markdown_it_emoji_1.default, { defs: index_2.default });
    md.use(markdown_it_footnote_1.default);
    md.use(markdown_it_task_lists_1.default);
    tag_1.default(md);
    math_1.default(md);
    widget_1.default(md);
    fence_1.default(md);
    wikilink_1.default(md);
    /**
     * renderMarkdown
     * @param markdown
     */
    function renderMarkdown(markdown) {
        try {
            var _a = transform_1.transformMarkdown(markdown, {
                forPreview: true,
                headingIdGenerator: new heading_id_generator_1.default(),
                forMarkdownExport: false,
                usePandocParser: false,
            }), slideConfigs = _a.slideConfigs, headings = _a.headings, outputString = _a.outputString, frontMatterString = _a.frontMatterString;
            var yamlConfig = {};
            try {
                yamlConfig = YAML.parse(frontMatterString.trim().replace(/^\-+/, "").replace(/\-+$/, "").trim());
            }
            catch (error) {
                yamlConfig = {};
            }
            var html = md.render(outputString);
            if (slideConfigs.length) {
                html = slide_1.parseSlides(html, slideConfigs);
                return {
                    html: html,
                    headings: headings,
                    slideConfigs: slideConfigs,
                    yamlConfig: yamlConfig,
                };
            }
            else {
                return {
                    html: html,
                    headings: headings,
                    slideConfigs: slideConfigs,
                    yamlConfig: yamlConfig,
                };
            }
        }
        catch (error) {
            return {
                html: "Failed to render markdown:\n" + JSON.stringify(error),
                headings: [],
                slideConfigs: [],
                yamlConfig: {},
            };
        }
    }
    exports.renderMarkdown = renderMarkdown;
    function performAfterWorks(previewElement, isPresentation) {
        if (isPresentation === void 0) { isPresentation = false; }
        renderWidgets(previewElement);
        renderCodeFences(previewElement, isPresentation);
    }
    var RevealJSThemes = {
        "beige.css": "beige.css",
        "black.css": "black.css",
        "blood.css": "blood.css",
        "league.css": "league.css",
        "moon.css": "moon.css",
        "night.css": "night.css",
        "serif.css": "serif.css",
        "simple.css": "simple.css",
        "sky.css": "sky.css",
        "solarized.css": "solarized.css",
        "white.css": "white.css",
    };
    var AutoPrismThemeMapForPresentation = {
        "beige.css": "pen-paper-coffee.css",
        "black.css": "one-dark.css",
        "blood.css": "monokai.css",
        "league.css": "okaidia.css",
        "moon.css": "funky.css",
        "night.css": "atom-dark.css",
        "serif.css": "github.css",
        "simple.css": "github.css",
        "sky.css": "default.css",
        "solarized.css": "solarized-light.css",
        "white.css": "default.css",
    };
    /**
     * renderPreview
     * @param previewElement, which should be <div> element
     * @param markdown
     */
    function renderPreview(previewElement, markdown, forRevealJSPrint, requires) {
        if (forRevealJSPrint === void 0) { forRevealJSPrint = false; }
        if (requires === void 0) { requires = {}; }
        return new Promise(function (resolve, reject) {
            var _a = renderMarkdown(markdown), html = _a.html, headings = _a.headings, slideConfigs = _a.slideConfigs, yamlConfig = _a.yamlConfig;
            previewElement.setAttribute("data-vickymd-preview", "true");
            if (!slideConfigs.length) {
                previewElement.innerHTML = html;
                performAfterWorks(previewElement);
                return resolve();
            }
            else {
                var id_1 = "reveal.js." + Date.now();
                // Slide
                previewElement.innerHTML = "";
                var iframe_1 = document.createElement("iframe");
                iframe_1.setAttribute("data-markdown", markdown);
                // Check wavedrom
                var wavedromScript = "";
                var wavedromInitScript = "";
                if (html.indexOf("wavedrom") >= 0) {
                    wavedromScript += "<script src=\"" + (requires.WaveDromSkinJS ||
                        "https://cdn.jsdelivr.net/npm/wavedrom@2.3.2/skins/default.js") + "></script>";
                    wavedromScript += "<script src=" + (requires.WaveDromJS ||
                        "https://cdn.jsdelivr.net/npm/wavedrom@2.3.2/wavedrom.min.js") + "></script>";
                    wavedromInitScript += "<script>\n  Reveal.addEventListener(\"ready\", ()=> {\n    WaveDrom.ProcessAll()\n  })      \n  </script>";
                }
                // Check mermaid. Copied from @shd101wyy/mume
                var mermaidScript = "";
                var mermaidInitScript = "";
                if (html.indexOf("mermaid") >= 0) {
                    mermaidScript = "<script type=\"text/javascript\" src=" + (requires.MermaidJS ||
                        "https://cdn.jsdelivr.net/npm/mermaid/dist/mermaid.min.js") + "></script>";
                    mermaidInitScript += "<script>\n        if (window['MERMAID_CONFIG']) {\n          window['MERMAID_CONFIG'].startOnLoad = false\n          window['MERMAID_CONFIG'].cloneCssStyles = false\n        }\n        mermaid.initialize(window['MERMAID_CONFIG'] || {})\n        if (typeof(window['Reveal']) !== 'undefined') {\n          function mermaidRevealHelper(event) {\n            var currentSlide = event.currentSlide\n            var diagrams = currentSlide.querySelectorAll('.mermaid')\n            for (var i = 0; i < diagrams.length; i++) {\n              var diagram = diagrams[i]\n              if (!diagram.hasAttribute('data-processed')) {\n                mermaid.init(null, diagram, ()=> {\n                  Reveal.slide(event.indexh, event.indexv)\n                })\n              }\n            }\n          }\n          Reveal.addEventListener('slidechanged', mermaidRevealHelper)\n          Reveal.addEventListener('ready', mermaidRevealHelper)\n        } else {\n          mermaid.init(null, document.getElementsByClassName('mermaid'))\n        }\n        </script>";
                }
                // reveal.js
                var revealJSConfig = {};
                if (yamlConfig && yamlConfig["presentation"]) {
                    revealJSConfig = yamlConfig["presentation"] || {};
                }
                var revealJSTheme = "white.css";
                if (revealJSConfig && revealJSConfig["theme"]) {
                    revealJSTheme = RevealJSThemes[revealJSConfig["theme"]] || "white.css";
                }
                var revealJSCodeBlockTheme = AutoPrismThemeMapForPresentation[revealJSTheme];
                iframe_1.style.border = "none";
                iframe_1.style.width = "100%";
                iframe_1.style.height = "100%";
                iframe_1.style.boxSizing = "border-box";
                iframe_1.src = "javascript:;";
                previewElement.appendChild(iframe_1);
                iframe_1.contentWindow.document.open();
                iframe_1.contentWindow.document.write("<html>\n    <head>\n      <meta charset=\"utf-8\" />\n      <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />\n      \n      <!-- reveal.js styles -->\n      <link rel=\"stylesheet\" href=" + (requires.RevealCSS ||
                    "https://cdn.jsdelivr.net/npm/reveal.js@3.9.2/css/reveal.css") + ">\n      <link rel=\"stylesheet\" href=" + ((requires.RevealThemeCSSFunc &&
                    requires.RevealThemeCSSFunc(revealJSTheme)) ||
                    "https://cdn.jsdelivr.net/npm/reveal.js@3.9.2/css/theme/" + revealJSTheme) + ">    \n      " + (forRevealJSPrint
                    ? "<link rel=\"stylesheet\" href=" + (requires.RevealPrintPDFCSS ||
                        "https://cdn.jsdelivr.net/npm/reveal.js@3.9.2/css/print/pdf.css") + ">"
                    : "") + "\n  \n      <!-- katex -->\n      <link rel=\"stylesheet\" href=" + (requires.KaTeXCSS ||
                    "https://cdn.jsdelivr.net/npm/katex@0.11.1/dist/katex.min.css") + ">\n  \n      <!-- prism github theme -->\n      <link href=" + ((requires.PrismCSSFunc &&
                    requires.PrismCSSFunc(revealJSCodeBlockTheme)) ||
                    "https://cdn.jsdelivr.net/npm/@shd101wyy/mume@0.4.7/styles/prism_theme/" + revealJSCodeBlockTheme) + " rel=\"stylesheet\">\n    \n      <!-- mermaid -->\n      " + mermaidScript + "\n  \n      <!-- wavedrom -->\n      " + wavedromScript + "\n    </head>\n    <body>\n    " + html + "\n    </body>\n    <!-- reveal.js -->\n    " + (forRevealJSPrint
                    ? "\n    <script>\n    window.history.replaceState(\"\", \"\", \"?print-pdf\")\n    </script>\n    "
                    : "") + "\n    <script src=" + (requires.RevealJS ||
                    "https://cdn.jsdelivr.net/npm/reveal.js@3.9.2/js/reveal.min.js") + "></script>\n  \n    <!-- prism.js -->\n    <script src=" + (requires.PrismJS ||
                    "https://cdn.jsdelivr.net/npm/prismjs@1.17.1/prism.min.js") + "></script>\n  \n    <!-- mermaid -->\n    " + mermaidInitScript + "\n  \n    <!-- wavedrom -->\n    " + wavedromInitScript + "\n  \n    <!-- initialize reveal.js -->\n    <script>\n  Reveal.initialize(" + JSON.stringify(__assign({ margin: 0.1 }, revealJSConfig)) + ");\n  Reveal.addEventListener('ready', function(event) {\n    parent.postMessage({event: \"reveal-ready\", id:\"" + id_1 + "\"})\n  })\n    </script>\n  </html>");
                iframe_1.contentWindow.document.close();
                window.addEventListener("message", function (event) {
                    if (event.data &&
                        event.data.event === "reveal-ready" &&
                        event.data.id === id_1) {
                        performAfterWorks(iframe_1.contentWindow.document.body, true);
                        return resolve();
                    }
                });
            }
        });
    }
    exports.renderPreview = renderPreview;
    function renderWidgets(previewElement) {
        // render widgets
        var widgets = previewElement.getElementsByClassName("vickymd-widget");
        for (var i = 0; i < widgets.length; i++) {
            var widgetSpan = widgets[i];
            var widgetName = widgetSpan.getAttribute("data-widget-name");
            var widgetAttributesStr = widgetSpan.getAttribute("data-widget-attributes");
            var widgetAttributes = {};
            try {
                widgetAttributes = JSON.parse(widgetAttributesStr);
            }
            catch (error) {
                widgetAttributes = {};
            }
            var widget = null;
            var widgetCreator = index_1.getWidgetCreator(widgetName);
            if (!widgetCreator) {
                continue;
            }
            widget = widgetCreator({
                attributes: widgetAttributes,
                isPreview: true,
            });
            if (widget) {
                widget.classList.add("vickymd-widget");
                widget.setAttribute("data-widget-name", widgetName);
                widget.setAttribute("data-widget-attributes", widgetAttributesStr);
                widgetSpan.replaceWith(widget);
            }
            widgetSpan.replaceWith(widget);
        }
    }
    function renderCodeFences(previewElement, isPresentation) {
        if (isPresentation === void 0) { isPresentation = false; }
        var fences = previewElement.getElementsByClassName("vickeymd-fence");
        var copyFences = [];
        for (var i = 0; i < fences.length; i++) {
            // replaceChild will cause issue, therefore we need to make a copy of the original elements array
            copyFences.push(fences[i]);
        }
        for (var i = 0; i < copyFences.length; i++) {
            var fence = copyFences[i];
            var parsedInfo = fence.getAttribute("data-parsed-info") || "{}";
            var info = {};
            try {
                info = JSON.parse(parsedInfo);
            }
            catch (error) {
                info = {};
            }
            var code = fence.textContent;
            var language = info["language"] || "text";
            // TODO: Diagrams rendering
            if (language.match(/^(puml|plantuml)$/)) {
                // Diagrams
                var element = fold_code_with_plantuml_1.PlantUMLRenderer(code, info).element;
                fence.replaceWith(element);
                continue;
            }
            else if (language.match(/^echarts$/)) {
                var element = fold_code_with_echarts_1.EchartsRenderer(code, info).element;
                fence.replaceWith(element);
            }
            else if (language.match(/^mermaid$/)) {
                if (!isPresentation) {
                    var element = fold_code_with_mermaid_1.MermaidRenderer(code, info).element;
                    fence.replaceWith(element);
                }
            }
            else if (language.match(/^vega$/)) {
                var _a = fold_code_with_vega_1.VegaRenderer(code, info), element = _a.element, asyncRenderer = _a.asyncRenderer;
                fence.replaceWith(element);
                if (asyncRenderer)
                    asyncRenderer();
            }
            else if (language.match(/^vega\-lite$/)) {
                var _b = fold_code_with_vega_lite_1.VegaLiteRenderer(code, info), element = _b.element, asyncRenderer = _b.asyncRenderer;
                fence.replaceWith(element);
                if (asyncRenderer)
                    asyncRenderer();
            }
            else if (language.match(/^wavedrom$/i)) {
                if (!isPresentation) {
                    var _c = fold_code_with_wavedrom_1.WaveDromRenderer(code, info), element = _c.element, asyncRenderer = _c.asyncRenderer;
                    fence.replaceWith(element);
                    if (asyncRenderer)
                        asyncRenderer();
                }
            }
            else {
                // Normal code block
                var pre = document.createElement("pre");
                if (!window["Prism"]) {
                    pre.textContent = code;
                    fence.replaceWith(pre);
                    continue;
                }
                if (!(language in window["Prism"].languages)) {
                    pre.classList.add("language-text");
                    pre.textContent = code;
                    fence.replaceWith(pre);
                    continue;
                }
                try {
                    var html = window["Prism"].highlight(code, window["Prism"].languages[language], language);
                    pre.classList.add("language-" + language);
                    pre.innerHTML = html; // <= QUESTION: Is this safe?
                    fence.replaceWith(pre);
                    continue;
                }
                catch (error) {
                    pre.classList.add("language-error");
                    pre.textContent = error.toString();
                    fence.replaceWith(pre);
                    continue;
                }
            }
        }
    }
    /**
     * Print as PDF
     * @param previewElement
     */
    function printPDF(previewElement, printOption, bannerElement) {
        if (printOption === void 0) { printOption = {}; }
        return new Promise(function (resolve, reject) {
            if (!window["html2pdf"]) {
                throw new Error("html2pdf is not imported. Failed to print pdf");
            }
            if (!bannerElement) {
                bannerElement = document.createElement("div");
                bannerElement.style.position = "fixed";
                bannerElement.style.width = "100%";
                bannerElement.style.height = "100%";
                bannerElement.style.top = "0";
                bannerElement.style.left = "0";
                bannerElement.style.textAlign = "center";
                bannerElement.style.backgroundColor = "#fff";
                bannerElement.style.zIndex = "9999";
                bannerElement.innerHTML = "<p>Printing ...</p>";
            }
            document.body.appendChild(bannerElement);
            var oldDisplayStyle = previewElement.style.display;
            var oldPositionStyle = previewElement.style.position;
            var oldPadding = previewElement.style.padding;
            var oldMargin = previewElement.style.margin;
            previewElement.style.display = "block";
            previewElement.style.position = "relative";
            previewElement.style.padding = "0";
            previewElement.style.margin = "0";
            var restore = function () {
                document.body.removeChild(bannerElement);
                previewElement.style.display = oldDisplayStyle;
                previewElement.style.position = oldPositionStyle;
                previewElement.style.padding = oldPadding;
                previewElement.style.margin = oldMargin;
            };
            html2pdf()
                .set(printOption)
                .from(previewElement)
                .save()
                .then(function () {
                restore();
                return resolve();
            })
                .catch(function (error) {
                restore();
                return reject(error);
            });
        });
    }
    exports.printPDF = printPDF;
    function printPreview(previewElement, bannerElement, elementsWhosePositionsToInitial, extraMediaPrintCSS, timeout) {
        var _this = this;
        if (elementsWhosePositionsToInitial === void 0) { elementsWhosePositionsToInitial = []; }
        if (extraMediaPrintCSS === void 0) { extraMediaPrintCSS = ""; }
        if (timeout === void 0) { timeout = 2000; }
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var styleElement, oldDisplayStyle, oldPositionStyle, oldWidthStyle, oldHeightStyle, oldOverflowStyle, oldTopStyle, oldLeftStyle, oldPaddingStyle, oldMarginStyle, elements, oldPositions, isPresentation, presentationMarkdown, presentationIframe, restore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bannerElement) {
                            bannerElement = document.createElement("div");
                            bannerElement.style.position = "fixed";
                            bannerElement.style.width = "100%";
                            bannerElement.style.height = "100%";
                            bannerElement.style.top = "0";
                            bannerElement.style.left = "0";
                            bannerElement.style.textAlign = "center";
                            bannerElement.style.backgroundColor = "#fff";
                            bannerElement.style.zIndex = "9999";
                            bannerElement.innerHTML = "<p>Preparing ...</p>";
                        }
                        bannerElement.classList.add("print-hidden");
                        document.body.appendChild(bannerElement);
                        styleElement = document.createElement("style");
                        styleElement.innerHTML = "\n@media print {\n  .print-hidden {\n    display: none;\n  }\n\n  " + extraMediaPrintCSS + "\n}\n";
                        document.body.appendChild(styleElement);
                        oldDisplayStyle = previewElement.style.display;
                        oldPositionStyle = previewElement.style.position;
                        oldWidthStyle = previewElement.style.width;
                        oldHeightStyle = previewElement.style.height;
                        oldOverflowStyle = previewElement.style.overflow;
                        oldTopStyle = previewElement.style.top;
                        oldLeftStyle = previewElement.style.left;
                        oldPaddingStyle = previewElement.style.padding;
                        oldMarginStyle = previewElement.style.margin;
                        previewElement.style.display = "block";
                        previewElement.style.position = "absolute";
                        previewElement.style.width = "100%";
                        previewElement.style.height = "auto";
                        previewElement.style.overflow = "auto";
                        previewElement.style.zIndex = "9999";
                        previewElement.style.top = "0";
                        previewElement.style.left = "0";
                        previewElement.style.padding = "0";
                        previewElement.style.margin = "0";
                        elements = [];
                        oldPositions = [];
                        elementsWhosePositionsToInitial.forEach(function (selector) {
                            var elem = document.querySelector(selector);
                            if (elem) {
                                elements.push(elem);
                                oldPositions.push(elem.style.position || "relative");
                                elem.style.position = "initial";
                            }
                        });
                        isPresentation = false;
                        presentationMarkdown = "";
                        presentationIframe = null;
                        if (!
                        // It's presentation
                        (previewElement.childElementCount > 0 &&
                            previewElement.children[0].tagName &&
                            previewElement.children[0].tagName.toUpperCase() === "IFRAME")) 
                        // It's presentation
                        return [3 /*break*/, 2];
                        // rerender
                        isPresentation = true;
                        presentationMarkdown = previewElement.children[0].getAttribute("data-markdown");
                        return [4 /*yield*/, renderPreview(previewElement, presentationMarkdown, true)];
                    case 1:
                        _a.sent();
                        presentationIframe = previewElement.children[0];
                        _a.label = 2;
                    case 2:
                        restore = function () {
                            document.body.removeChild(bannerElement);
                            document.body.removeChild(styleElement);
                            previewElement.style.display = oldDisplayStyle;
                            previewElement.style.position = oldPositionStyle;
                            previewElement.style.width = oldWidthStyle;
                            previewElement.style.height = oldHeightStyle;
                            previewElement.style.overflow = oldOverflowStyle;
                            previewElement.style.top = oldTopStyle;
                            previewElement.style.left = oldLeftStyle;
                            previewElement.style.padding = oldPaddingStyle;
                            previewElement.style.margin = oldMarginStyle;
                            if (isPresentation) {
                                // rerender
                                renderPreview(previewElement, presentationMarkdown);
                            }
                            elements.forEach(function (elem, idx) {
                                elem.style.position = oldPositions[idx];
                            });
                        };
                        setTimeout(function () {
                            if (isPresentation) {
                                presentationIframe.contentWindow.print();
                            }
                            else {
                                window.print();
                            }
                            restore();
                            return resolve();
                        }, timeout);
                        return [2 /*return*/];
                }
            });
        }); });
    }
    exports.printPreview = printPreview;
});
